/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Type_Weight_RangeInputs */

const fr_load_type_weight_range = /** @type {(inputs: Load_Type_Weight_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids (plage)`)
};

/**

* @param {Load_Type_Weight_RangeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const load_type_weight_range = /** @type {((inputs?: Load_Type_Weight_RangeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Type_Weight_RangeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_load_type_weight_range(inputs)
});